/**
 * Who It's For Section - The Last Mile Journey
 */

import { useEffect, useState } from "react";
import { MilestoneItem } from "./MilestoneItem";
import { milestones } from "./utils";

export const WhoItsForSection = () => {
  const [visibleMilestones, setVisibleMilestones] = useState<number[]>([]);

  useEffect(() => {
    const timers = milestones.map((milestone, index) =>
      setTimeout(
        () => setVisibleMilestones((prev) => [...prev, milestone.id]),
        index * 400
      )
    );
    return () => timers.forEach((timer) => clearTimeout(timer));
  }, []);

  return (
    <div className="relative overflow-hidden bg-gradient-to-br from-[#c76cf8] via-[#2637a4]/80 to-[#c76cf8] py-24 px-4 sm:px-6 lg:px-8">
      <div className="absolute inset-0 bg-[linear-gradient(rgba(147,51,234,0.15)_1px,transparent_1px),linear-gradient(90deg,rgba(147,51,234,0.15)_1px,transparent_1px)] bg-[size:64px_64px]" />
      <div className="absolute top-40 left-20 w-96 h-96 bg-purple-600/30 rounded-full blur-3xl animate-pulse" />
      <div
        className="absolute bottom-40 right-20 w-96 h-96 bg-violet-500/25 rounded-full blur-3xl animate-pulse"
        style={{ animationDelay: "1.5s" }}
      />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-br from-purple-900/40 to-violet-800/35 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto">
        <div className="text-center mb-20 animate-fade-in">
          {/* <div className="inline-block mb-6">
            <span className="bg-primary/20 backdrop-blur-sm text-primary-foreground px-5 py-2.5 rounded-full text-sm font-bold flex items-center gap-2 border border-primary/30">
              🚀 The Last Mile Journey
            </span>
          </div> */}
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-8 tracking-tight">
            Who It's For
          </h2>
          <p className="text-xl sm:text-2xl text-white/90 max-w-4xl mx-auto leading-relaxed font-medium">
            You've come far — you work in tech, use English, and collaborate
            globally. Now it's time for the last mile: real confidence.
          </p>
        </div>

        {/* Desktop */}
        <div className="hidden lg:block relative mb-20">
          <div className="relative max-w-6xl mx-auto mb-16">
            <div
              className="absolute left-[8.33%] right-[8.33%] border-t-[3px] border-dashed border-white/70"
              style={{ top: "24px" }}
            />
          </div>

          <div className="grid grid-cols-3 gap-12 max-w-6xl mx-auto">
            {milestones.map((milestone) => (
              <MilestoneItem
                key={milestone.id}
                milestone={milestone}
                isVisible={visibleMilestones.includes(milestone.id)}
              />
            ))}
          </div>
        </div>

        {/* Mobile */}
        <div className="lg:hidden relative max-w-2xl mx-auto">
          <div className="absolute left-6 top-6 bottom-6 border-l-[3px] border-dashed border-white/70" />
          <div className="space-y-12">
            {milestones.map((milestone) => (
              <MilestoneItem
                key={milestone.id}
                milestone={milestone}
                isVisible={visibleMilestones.includes(milestone.id)}
                isMobile
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
